import { cubicBezier } from '../internal';
export var ease = cubicBezier(.25, .1, .25, .1);
